export default () => ({
    overflow: 'auto',
});
